var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-input",
    {
      ref: "input",
      class: { "cursor-pointer": _vm.hasNewLine },
      attrs: {
        label: _vm.label,
        value: _vm.displayedText,
        disabled: _vm.disabled,
        fancy: "",
        icon: "edit",
        name: "description",
      },
      on: {
        focus: function ($event) {
          return _vm.onFocus($event)
        },
        input: function ($event) {
          return _vm.onInputElInput($event)
        },
        "icon-click": function ($event) {
          return _vm.editIconClicked()
        },
        keyup: [
          function ($event) {
            return _vm.onKeyUp($event)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onKeyUp($event)
          },
          function ($event) {
            if (!$event.ctrlKey) return null
            return _vm.onKeyUpCtrl($event)
          },
        ],
        mouseup: function ($event) {
          return _vm.onMouseUp()
        },
      },
    },
    [
      _c(
        "w-modal",
        {
          attrs: { slot: "modal-space" },
          slot: "modal-space",
          model: {
            value: _vm.modalOpen,
            callback: function ($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen",
          },
        },
        [
          _c(
            "app-text-area-modal",
            {
              ref: "modal",
              attrs: {
                editor: _vm.editor,
                title: _vm.computedModalTitle,
                "ok-text": _vm.okText,
                "cancel-text": _vm.cancelText,
                "force-editor": _vm.forceModalEditor,
                name: "wide-description",
                value: _vm.value,
              },
              on: {
                close: function ($event) {
                  _vm.modalOpen = false
                },
                input: function ($event) {
                  return _vm.onInput($event)
                },
                confirm: function ($event) {
                  return _vm.onConfirm()
                },
                keyup: function ($event) {
                  return _vm.onKeyUp($event)
                },
                "cursor-position": function ($event) {
                  return _vm.$emit("cursor-position", $event)
                },
                "temp-text": function ($event) {
                  return _vm.$emit("modal-text", $event)
                },
              },
            },
            [_vm._t("below-editor", null, { slot: "below-editor" })],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }